export default __webpack_public_path__ + "static/media/noun-sitting-fox-eth-4332366.f28ceaf8.png";